// Stable document type keys persisted to the backend.
// Labels are localized via DOCUMENTS.TYPES.* i18n keys; never persist display strings.
export const DOCUMENT_TYPE_KEYS = [
  'contract',
  'agreement',
  'identity_document',
  'receipt',
  'certificate',
  'proposal',
  'other',
];

export const DOCUMENT_STATUS_KEYS = [
  'draft',
  'requested',
  'received',
  'in_review',
  'awaiting_external',
  'awaiting_signature',
  'fully_executed',
  'ready',
  'dispatched',
  'completed',
  'archived',
];

// Custom lifecycle states can be any snake_case string without an i18n entry;
// humanize them for display: awaiting_external → "Awaiting external".
export const humanizeDocumentStatus = status => {
  const words = String(status || '').replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

// Status label resolution shared by the badge and filter lists: prefer the
// i18n label when one exists, fall back to the humanized state otherwise.
export const documentStatusLabel = (status, t, te) => {
  const key = `DOCUMENTS.STATUS.${String(status).toUpperCase()}`;
  return te(key) ? t(key) : humanizeDocumentStatus(status);
};

// Canonical status chip recipe: bg-n-{color}-9/10 text-n-{color}-11.
// Adjacent lifecycle stages never share a hue.
export const DOCUMENT_STATUS_CLASSES = {
  draft: 'bg-n-slate-9/10 text-n-slate-11',
  requested: 'bg-n-amber-9/10 text-n-amber-11',
  received: 'bg-n-blue-9/10 text-n-blue-11',
  in_review: 'bg-n-iris-9/10 text-n-iris-11',
  awaiting_external: 'bg-n-amber-9/10 text-n-amber-11',
  awaiting_signature: 'bg-n-violet-9/10 text-n-violet-11',
  fully_executed: 'bg-n-teal-9/10 text-n-teal-11',
  ready: 'bg-n-blue-9/10 text-n-blue-11',
  dispatched: 'bg-n-violet-9/10 text-n-violet-11',
  completed: 'bg-n-teal-9/10 text-n-teal-11',
  archived: 'bg-n-slate-9/10 text-n-slate-11',
  quarantined: 'bg-n-ruby-9/10 text-n-ruby-11',
};
